import { createGlobalStyle } from 'styled-components';

const CELESTE_APPROX = '#ccc';
const THD_LINK = '#3e7697';
const THD_ORANGE = '#F96302';
const DARK_TEXT = '#333';
const WHITE = '#fff';
const ALERT_RED = 'rgb(244, 67, 54)';
const BULK_PRICING = '#0F8E48';

export const ScreenSize = {
  mobileS: '360px',
  mobileM: '640px',
  mobileL: '768px',
  tablet: '1024px',
  laptop: '1880px',
  desktop: '2560px',
};

export const Theme = {
  scheme: 'nucleus',
  colors: {
    primaryBackground: '#f5f5f5',
    secondaryBackground: WHITE,
    alertBackground: '#fdfdef',
    alertBorder: '#ffd14b',
    active: THD_ORANGE,
    inActive: CELESTE_APPROX,
    primaryText: '#444444',
    alertText: ALERT_RED,
    linkText: THD_LINK,
    darkText: DARK_TEXT,
    bulkPricingText: BULK_PRICING,
  },
  typography: {
    heading:
      'helvetica-neue-light, helvetica-neue, helvetica neue, helvetica, arial, sans-serif',
  },
  fontFamily: 'helvetica-neue, helvetica neue, helvetica, arial, sans-serif',
  mediaQuery: {
    mobileS: `@media (min-width: ${ScreenSize.mobileS})`,
    mobileM: `@media(min-width: ${ScreenSize.mobileM})`,
    mobileL: `@media(min-width: ${ScreenSize.mobileL})`,
    tablet: `@media(min-width: ${ScreenSize.tablet})`,
    laptop: `@media(min-width: ${ScreenSize.laptop})`,
    desktop: `@media(min-width: ${ScreenSize.desktop})`,
  },
};

export const GlobalStyle = createGlobalStyle`
  :root {
    font-family: helvetica-neue, helvetica neue, helvetica, arial, sans-serif;
    background-color: ${Theme.colors.primaryBackground};
  }
`;
